import React from "react";
import { z } from "zod";
import { FORGET_PASSWORD_ADMIN } from "../../services/ApiCalls";
import { toast } from "react-toastify";
import { zodResolver } from "@hookform/resolvers/zod";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import styles from "../../layout/Auth/Auth.module.scss";
import { Button, Form, Container, Row, Col } from "react-bootstrap";

const schema = z.object({
  email: z
    .string()
    .min(1, { message: "Email is required" })
    .email("Invalid email address"),
});

const ForgetPassword = ({ setEmail, setIsOtpSended }) => {
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: zodResolver(schema),
  });
  console.log(errors , "errorrrrrrrrrrrr")
  const submitHandler = async (data) => {
    try {
      const res = await FORGET_PASSWORD_ADMIN(data);
        
      if (res?.data?.status === "success") {
        toast.success(res?.data?.message);
        setEmail(data.email);
        setIsOtpSended(true);
      } else {
        toast.error(res?.data?.message);
      }
    } catch (error) {
      toast.error("Something went wrong");
    }
  };
  return (
    <div className="w-100 inner">
      <div className="top py-2">
        <h4 className="m-0 fw-sbold">Forgot Password</h4>
      </div>
      <Form className={`${styles.form}`} onSubmit={handleSubmit(submitHandler)}>
        <Row>
          <Col lg="12" className="my-2">
            <input
              type="email"
              className={`${styles.formControl} form-control bg-white`}
              placeholder="Email Address"
              {...register("email")}
            />
            {
              <p className="errorColor">
                {errors?.email && errors.email.message}
              </p>
            }
          </Col>
          <Col lg="8" className="my-2">
            <div className={`${styles.btnWrpper} btnWrpper`}>
              <Button
                className="d-flex align-items-center justify-content-center w-100 commonBtn"
                type="submit"
              >
                Submit
              </Button>
            </div>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default ForgetPassword;
